import React, { useState } from "react";
import visionLogo from "../../images/vision-logo.png";
import backImg from "../../images/back-img.png";
import { Link } from "react-router-dom";
import axios from "axios";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  function forgotPassword(e) {
    e.preventDefault();
    setDisabled(true);
    if (email == "") {
      setEmailError(true);
      return false;
    } else {
      let url = process.env.REACT_APP_API_URL + "/forgot-password";
      let payload = { Email: email };
      axios
        .post(url, payload)
        .then((res) => {
          setIsSuccess(true);
          setDisabled(false);
        })
        .catch((err) => {
          setIsSuccess(false);
          let message =
            typeof err.response !== "undefined"
              ? err.response.data.message
              : "Email not registered with us.";
          setTimeout(() => {
            setDisabled(false);
          }, 500);
          setEmailError(true);
          setErrorMessage(message);
        });
    }
  }

  return (
    <section className="login" style={{ backgroundImage: `url(${backImg})` }}>
      <div className="login-container h-100">
        <div className="row justify-content-lg-end justify-content-center align-items-center h-100">
          <div className="width-xl-28 width-lg-55 width-md-80">
            <div className="card p-4 rounded-4">
              <div className="card-header bg-white border-0 text-center py-3">
                <img src={visionLogo} alt="" />
              </div>
              {!isSuccess ? (
                <div className="card-body">
                  <h6 className="card-title text-center title-bold fs-20 mb-1">
                    Forgot Password
                  </h6>
                  <div className="spacer-2"></div>
                  <form onSubmit={forgotPassword}>
                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label fw-medium input-bold"
                      >
                        Email*
                      </label>
                      <input
                        type="email"
                        className={
                          "form-control input-lg " +
                          (emailError ? " is-invalid" : "")
                        }
                        id="email"
                        placeholder="Email"
                        onChange={(e) => {
                          setEmailError(false);
                          setEmail(e.target.value);
                          if (e.target.value && password) {
                            setDisabled(false);
                          } else {
                            setDisabled(true);
                          }
                        }}
                      />
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                    <div className="spacer-2"></div>
                    <div className="d-grid">
                      <button
                        disabled={disabled}
                        type="submit"
                        className="btn btn-primary btn-lg fw-medium text-white d-flex align-items-center justify-content-center"
                      >
                        Send
                      </button>
                    </div>
                  </form>
                  <Link
                    to="/"
                    className="fw-medium text-dark d-flex align-items-center justify-content-center"
                  >
                    Login
                  </Link>
                </div>
              ) : (
                <div className="card-body">
                  <h2 className="card-title text-center title-bold fs-32 mb-1">
                    Check your inbox.
                  </h2>
                  <p className="text-center fs-15 text-lite">
                    We've sent a reset password link to your registered email
                    address. If you can't see it, check your spam folder in case
                    it has accidentally landed there.
                  </p>
                  <Link
                    to="/"
                    className="fw-medium text-dark d-flex align-items-center justify-content-center"
                  >
                    Login
                  </Link>
                </div>
              )}
              <div className="card-footer bg-white border-0 py-3">
                <p className="fs-13 text-center mb-0">
                  Copyright@2023. Vision Produce.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default ForgotPassword;
